import { IPayload } from 'models/Global'
import {
  IGetUpshifterWorkHistoryParams,
  IPostUpshifterWorkHistoryParams,
  IPutUpshifterWorkHistoryParams,
  IUpshifterWorkHistory,
} from 'models/UpshifterWorkHistory'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class UpshifterWorkHistoryApi {
  constructor(private axios: AxiosService) {}

  getUpshifterWorkHistory = async (params?: IGetUpshifterWorkHistoryParams) => {
    const response = await this.axios.get<IPayload<IUpshifterWorkHistory[]>>(
      Endpoints.getUpshifterWorkHistory,
      params
    )
    return response
  }

  postUpshifterWorkHistory = async (params: IPostUpshifterWorkHistoryParams) => {
    const response = await this.axios.post<IPayload<IUpshifterWorkHistory>>(
      Endpoints.postUpshifterWorkHistory,
      params
    )
    return response
  }

  putUpshifterWorkHistory = async (id: number, params: IPutUpshifterWorkHistoryParams) => {
    const response = await this.axios.put<IPayload<IUpshifterWorkHistory>>(
      Endpoints.putUpshifterWorkHistory(id),
      params
    )
    return response
  }

  deleteWorkExperience = async (workExperienceId: number) => {
    const response = await this.axios.delete<{}>(Endpoints.deleteWorkExperience(workExperienceId))
    return response
  }
}
